module.exports = __webpack_public_path__ + "images/signal_5.eab64270d270673869d38c2455430c27.png";